import { render } from "./textarea.html?vue&type=template&id=2df8d0ce&scoped=true&ts=true"
import script from "./textarea.ts?vue&type=script&lang=ts"
export * from "./textarea.ts?vue&type=script&lang=ts"

import "./textarea.scss?vue&type=style&index=0&id=2df8d0ce&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df8d0ce"]])

export default __exports__